/* PrintFabrix — fabric price + shipping calculator
   Product = W x H x Qty x rate (rate from data-rate, default 1.50)
   Shipping = flat band by total sq ft (W x H x Qty), converted to ft first.
   Attach: <div class="pf-calc" data-rate="1.50" data-handle="polyester-260">…</div>
   Writes line-item properties on add-to-cart. */
(function(){
  const SHIPPING = [
    [10,36],[18,44],[36,56],[54,67],[72,83],[90,88],[108,96],[126,120],
    [144,136],[162,150],[180,163],[198,174],[216,195],[234,205],[Infinity,250]
  ];
  const TO_FT = { ft:1, in:1/12, cm:0.0328084, m:3.28084 };

  // Parse a merchant-editable shipping table from the theme setting.
  // Format: one band per line "max_sqft:price" — but any separator works
  // (newline, colon, comma, space), because we just tokenize the numbers and
  // '*' in order and pair them as (cap, price). "*" = largest catch-all band.
  // Returns null if empty so callers fall back to the built-in SHIPPING defaults.
  function parseShipTable(str){
    if(!str) return null;
    const tokens = str.match(/\*|\d+(?:\.\d+)?/g);
    if(!tokens || tokens.length < 2) return null;
    const rows = [];
    for(let i = 0; i + 1 < tokens.length; i += 2){
      const price = parseFloat(tokens[i+1]);
      if(isNaN(price)) continue;
      const cap = (tokens[i] === '*') ? Infinity : parseFloat(tokens[i]);
      rows.push([cap, price]);
    }
    rows.sort(function(a,b){ return a[0] - b[0]; });
    return rows.length ? rows : null;
  }

  function shipFor(sqft, table){
    const t = (table && table.length) ? table : SHIPPING;
    for(const [cap,price] of t){ if(sqft <= cap) return price; }
    return t[t.length-1][1];
  }

  function money(n){
    try { return n.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch(e){ return '₹' + n.toFixed(2); }
  }

  function initCalc(root){
    const rate = parseFloat(root.dataset.rate || '1.50');
    const priced = !isNaN(rate) && rate > 0;
    const shipTable = parseShipTable(root.dataset.shippingTable) || SHIPPING;
    // finishing prices come from section settings (data-fin-*), with sensible fallbacks
    const finPockets = parseFloat(root.dataset.finPockets || '5');
    const finEyelets = parseFloat(root.dataset.finEyelets || '3');
    const finVelcro  = parseFloat(root.dataset.finVelcro  || '15');
    const finHook    = parseFloat(root.dataset.finHook    || '8');
    const $ = s => root.querySelector(s);
    const setTxt = (s,v)=>{ const e = $(s); if(e) e.textContent = v; };

    function recompute(){
      const unit = $('.pf-unit').value;
      const w = Math.max(parseFloat($('.pf-w').value)||0, 0) * TO_FT[unit];
      const h = Math.max(parseFloat($('.pf-h').value)||0, 0) * TO_FT[unit];
      const qty = Math.max(parseInt($('.pf-qty').value)||1, 1);
      const sqft = w*h*qty;

      // finishing — flat charge per selected type (placement is a line-item property)
      const pockets = ($('.pf-pockets') && $('.pf-pockets').value) || '';
      const eyelets = ($('.pf-eyelets') && $('.pf-eyelets').value) || '';
      const velcro  = ($('.pf-velcro')  && $('.pf-velcro').value)  || '';
      const hook    = ($('.pf-hook')    && $('.pf-hook').value)    || '';
      let finishing = 0;
      if(pockets){ finishing += finPockets; }
      if(eyelets){ finishing += finEyelets; }
      if(velcro){  finishing += finVelcro; }
      if(hook){    finishing += finHook; }
      root.dataset.pockets = pockets;
      root.dataset.eyelets = eyelets;
      root.dataset.velcro = velcro;
      root.dataset.hook = hook;
      setTxt('.pf-pb-qty', String(qty));
      setTxt('.pf-pb-finish', money(finishing));

      const out = $('.pf-out');
      const priceValEl = $('.pf-price-val');
      const areaValEl = $('.pf-area-val');
      function setPrice(p, a){ if(priceValEl){ priceValEl.textContent = p; if(areaValEl) areaValEl.textContent = a; } }

      if(sqft <= 0){
        setPrice('—', 'enter width & height');
        setTxt('.pf-pb-base', 'Enter size'); setTxt('.pf-pb-qtyval', '—'); setTxt('.pf-pb-total', '—');
        if(!priceValEl){ out.innerHTML = '<span class="pf-muted">Enter width and height</span>'; }
        return;
      }

      // If fabric has no real price yet, route to mockup request instead of $0
      if(!priced){
        setPrice('On request', sqft.toFixed(1)+' sq ft');
        setTxt('.pf-pb-base', 'On request'); setTxt('.pf-pb-qtyval', '—'); setTxt('.pf-pb-total', 'On request');
        if(!priceValEl){ out.innerHTML =
          '<div class="pf-por">Price on request for this fabric — '
          + '<a href="#pf-mockup">get a free mockup &amp; quote →</a></div>'; }
        return;
      }

      let product = sqft * rate + finishing;

      // shipping is folded into the final price and never shown separately
      const shipping = shipFor(sqft, shipTable);
      let total = product + shipping;

      // Per-piece price so the order/checkout show quantity = pieces (each piece
      // identical). Round to the cent, then re-derive total = perUnit × qty so the
      // displayed total exactly matches what the cart charges (no rounding drift).
      const perUnit = Math.round((total / qty) * 100) / 100;
      total = Math.round(perUnit * qty * 100) / 100;

      setPrice(money(total), sqft.toFixed(1)+' sq ft'+(qty>1?' · '+qty+' pcs':''));
      // breakdown — shipping is folded into "Base print" so the rows sum to the grand total
      setTxt('.pf-pb-base', money(Math.max(total - finishing, 0)));
      setTxt('.pf-pb-finish', money(finishing));
      setTxt('.pf-pb-qtyval', money(perUnit)+' ea');
      setTxt('.pf-pb-total', money(total));
      if(!priceValEl){ out.innerHTML =
        '<div class="pf-line pf-total"><span>Your price · printed, finished &amp; shipped</span><b>'+money(total)+'</b></div>'
      + '<div class="pf-line pf-muted">Area: '+sqft.toFixed(1)+' sq ft'+(qty>1?' · '+qty+' pcs':'')+'</div>'; }

      // stash for add-to-cart line item properties
      root.dataset.sqft = sqft.toFixed(2);
      root.dataset.total = total.toFixed(2);
      root.dataset.perUnit = perUnit.toFixed(2);
      root.dataset.pieces = String(qty);
      root.dataset.shipping = shipping.toFixed(2);
    }

    root.querySelectorAll('input,select').forEach(el=>{
      el.addEventListener('input', recompute);
      el.addEventListener('change', recompute);
    });
    recompute();
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.pf-calc').forEach(initCalc);
  });
  // expose for theme add-to-cart handlers
  window.PFCalc = { shipFor, TO_FT };
})();
